import Vue from "vue";
import VueRouter from "vue-router";

// 路由数据
import routes from "./routes";

Vue.use(VueRouter);

// 导出路由 在 main.js 里使用
const router = new VueRouter({
  mode: "history",
  routes
});
// 数据统计
router.beforeEach(async (to, from, next) => {
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(["_trackPageview", "/#" + to.fullPath]);
    }
  }
  next();
});
//跳转页面以后回到页面顶部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

function getRoutesList(routes, pre) {
  return routes.reduce((array, route) => {
    const path = `${pre}${route.path}`;

    if (route.path !== "*") {
      array.push(path);
    }

    if (route.children) {
      array.push(...getRoutesList(route.children, `${path}/`));
    }

    return array;
  }, []);
}

//生成sitemap
function getRoutesXML() {
  const list = getRoutesList(
    router.options.routes,
    "https://www.sinvocloud.com"
  )
    .map(route => `<url><loc>${route}</loc></url>`)
    .join("\r\n");
  return `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
    ${list}
  </urlset>`;
}

console.log(getRoutesXML());

export default router;



// WEBPACK FOOTER //
// ./src/router/router.config.js